// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__ulGah","header":"Layout_header__3uUXp","logo":"Layout_logo__r3Zvy","main":"Layout_main__FxQfo"};